<template>
  <div class="dispute-shipment">
    <div v-if="dataLength">
      <div class="dispute-shipment-reason-type-dropdown">
        <form-select
          id="reason-type-dropdown"
          v-model="reasonType"
          :options="reasonTypeOptions"
          optional-label
          label="Reason Type" />
      </div>
      <div
        v-for="(item, index) in shipmentNotesData"
        :key="index"
        class="dispute-shipment-container">
        <accordian
          :expanded="item.expanded"
          :item="item"
          :index="index"
          @onCardToggle="onAccordianToggle">
          <div
            slot="accordian-header-content"
            class="dispute-shipment-container-accordian-header">
            <div class="dispute-shipment-container-accordian-header--content">
              <div
                class="dispute-shipment-container-accordian-header--content-name">
                <span
                  class="dispute-shipment-container-accordian-header--content-name-username">
                  User ID: {{ item.updated_by_user_name }}
                </span>
                <span v-if="item.updated_timestamp">{{
                  `${formatDate(
                    item.updated_timestamp,
                    "dd MMM yyyy"
                  )}, ${formatDate(item.updated_timestamp, "hh:mm")}` || "N/A"
                }}</span>
              </div>
            </div>
            <div class="dispute-shipment-container-header--content">
              <span class="dispute-shipment-container-header--content-reason">
                Reason
              </span>
              <span>{{ item.reason }}</span>
            </div>
          </div>
          <div
            v-if="item.expanded"
            slot="accordian-body"
            class="dispute-shipment-container-accordian-body">
            <div class="dispute-shipment-container-accordian-body--item">
              <span
                class="dispute-shipment-container-accordian-body--item-title">
                Description:
              </span>
              <span
                class="dispute-shipment-container-accordian-body--item-details">
                {{ item.justification }}
              </span>
            </div>
          </div>
        </accordian>
      </div>
    </div>
    <h4 v-else class="dispute-shipment-not-found">No Edit History Found</h4>
  </div>
</template>

<script>
// Constants
import { detailsShipmentNotesReasonType } from "@/config/constant.js";

// Utils
import { format } from "date-fns";

export default {
  name: "DisputeShipmentNotes",
  props: {
    data: {
      type: Array,
      default() {
        return;
      },
    },
  },
  data() {
    return {
      shipmentNotesData: [],
      reasonType: "",
      reasonTypeOptions: detailsShipmentNotesReasonType,
    };
  },
  computed: {
    dataLength() {
      return this.shipmentNotesData?.length > 0;
    },
  },
  created() {
    this.shipmentNotesData = this.data;
  },
  methods: {
    formatDate(data, type) {
      return format(data, type);
    },
    onAccordianToggle(data, index) {
      event.stopPropagation();
      let newArray = [...this.shipmentNotesData];
      newArray[index] = {
        ...data,
        expanded: !data.expanded,
      };
      this.shipmentNotesData = newArray;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.dispute-shipment {
  &-reason-type-dropdown {
    width: 110px;
  }

  &-not-found {
    color: var(--Gray-900);
    margin-bottom: 1rem;
  }

  &-container {
    margin: 1rem 0;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: var(--Blue-800);
      border-radius: 24px;
      margin-top: 32px;
    }

    &::after {
      content: "";
      height: calc(100% + 8px);
      position: absolute;
      top: 42px;
      left: 9px;
      width: 2px;
      background-color: var(--Blue-800);
    }

    &:last-child {
      margin-bottom: 0;

      &::after {
        content: none;
      }
    }

    &-accordian-header {
      display: flex;
      align-items: center;
      &--content {
        &-name {
          display: flex;
          flex-direction: column;
          margin-right: 2rem;
          font-family: "Maersk Text";
          font-size: 14px;
          color: var(--Blue-900-Darkest);

          &-username {
            font-weight: bold;
          }

          &-reason {
            color: var(--Gray-600);
          }
        }
      }
    }

    &-accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 60px;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &--item {
        display: flex;
        flex-direction: column;

        &-required-header {
          color: var(--Gray-600);
        }
      }
    }
  }
}
</style>
